import baseURL from "../config/api";
import axios from "../config/axios";

export const post_Child = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}parentChildRelationships?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const post_ResendInvitToChild = (invitationId:number, parentId: number) => {
    return axios({
        url: `${baseURL}parentChildRelationships/ResendInvitationForEnrollmentChild/${invitationId},${parentId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false
    }).then(response => response.data);
}

export const delete_EnrollmentChild = (primaryId: number, userId:number) => {
    return axios({
        url: `${baseURL}childInvitations?id=${primaryId}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}

export const getChildInvitationByJoinCode = (joinCode: string) => {
    return getFetch(`childInvitations/GetChildInvitationByJoinCode?joinCode=${joinCode}`)
}

export const getChildInvitationByUserIdandEmail = (id: string, email:string) => {
    return getFetch(`childInvitations/GetChildInvitationsByUserIdAndEmail/${id}/${email}`)
}

export const getEnrolledParnentCourses = (userId: number) => {
    return getFetch(`courses/GetCoursesAssignedByParent/${userId}`)
}

export const put_enrollChildCourse = (status: string, code: string, userId: number) => {
    return axios({
        url: `${baseURL}childInvitations/UpdateChildInvitationStatus/${status},${code},${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
    }).then(response => response.data);
}

export const put_enrollChildCourseByEmail = (status: string, email: string, code: string, userId: number) => {
    return axios({
        url: `${baseURL}childInvitations/UpdateChildInvitationStatusByEmail/${status},${email},${code},${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
    }).then(response => response.data);
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}